<!-- Navbar.svelte -->

<script>
  import { link } from 'svelte-spa-router';
  let burger, menu;
  $effect(() => {
    const toggle = () => {
      burger.classList.toggle('is-active');
      menu.classList.toggle('is-active');
    };
    burger.addEventListener('click', toggle);
    return () => burger.removeEventListener('click', toggle);
  });
</script>

<nav class="navbar" aria-label="main navigation">
	<div class="navbar-brand">
		<a class="navbar-item" href="https://bulma.io" aria-label="Bulma homepage"></a>

		<button
			class="navbar-burger"
			aria-label="menu"
			aria-expanded="false"
			aria-controls="navbarMenu"
			bind:this={burger}
		>
			<span style="background-color:black;" aria-hidden="true"></span>
			<span style="background-color:black;" aria-hidden="true"></span>
			<span style="background-color:black;" aria-hidden="true"></span>
		</button>
	</div>

	<div id="navbarMenu" class="navbar-menu" bind:this={menu}>
		<div class="navbar-start">
			<a use:link class="navbar-item" href="/">Home</a>
		</div>
	</div>
</nav>
